import ClipboardJS from 'clipboard';

$(function () {
    initClipboardJS();
});

window.initClipboardJS = function () {
    if (window.clipboardInstance != undefined) {
        window.clipboardInstance.destroy();
    }

    window.clipboardInstance = new ClipboardJS('button[data-clipboard-text]');
};

window.initClipboardJSModal = function () {
    if (window.clipboardInstance != undefined) {
        window.clipboardInstance.destroy();
    }

    window.clipboardInstance = new ClipboardJS('button[data-clipboard-text]', {
        container: document.getElementById('modalAjaxLoaded')
    });
};
